export default __webpack_public_path__ + "static/media/Konfirmasi Data.676f1e61.svg";